"use client";

import { useMatchInvitations } from "@/hooks/use-match-invitations";
import { MatchInvitationDialog } from "./components/MatchInvitationDialog";

export function GlobalInvitationDialog() {
  const {
    dialogState,
    isProcessing,
    acceptInvitation,
    declineInvitation,
    confirmMatch,
    closeDialog,
  } = useMatchInvitations();

  if (!dialogState.isOpen || !dialogState.invitation || !dialogState.opponent) {
    return null;
  }

  const handleAccept = async () => {
    if (dialogState.type === "received") {
      // First acceptance - user is accepting the challenge
      await acceptInvitation(dialogState.invitation!.id);
    } else if (dialogState.type === "accepted") {
      // Second acceptance - challenger is confirming the match
      await confirmMatch(dialogState.invitation!.id);
    }
  };

  const handleDecline = async (reason?: string) => {
    await declineInvitation(dialogState.invitation!.id, reason);
  };

  return (
    <MatchInvitationDialog
      isOpen={dialogState.isOpen}
      invitation={dialogState.invitation}
      opponent={dialogState.opponent}
      onAccept={handleAccept}
      onDecline={handleDecline}
      onClose={closeDialog}
      isProcessing={isProcessing}
      mode={dialogState.type || "received"}
    />
  );
}
